var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"36ced5952c9bc631c3fb006e03a25d2df57a3de5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web@leatherspa"]={id:"36ced5952c9bc631c3fb006e03a25d2df57a3de5"};
      